import { useState, useRef } from "react";
import { useLocalizedStrings } from "../Localization";

export function TurnableImage(props: { Viewer: string, src: string; alt: string }) {
    const L = useLocalizedStrings();
    const [rotation, setRotation] = useState(0);
    const [imageError, isImageError] = useState(false);
    const ref = useRef<HTMLImageElement | null>(null);

    const modernUI = window.location.pathname.includes("/a/");

    if (imageError) {
      return <li>
        <a href={props.src}
          onClick={async (e) => {
            e.preventDefault();
            window.open(props.src, "_blank");
          }}
          rel="noopener noreferrer" target="_blank">
          View Document
        </a>{" "}
      </li>
    }
    return <>
      {props.Viewer === 'screener' &&
        <button 
          className="border-0 rounded-sm bg-gray-200 mb-1"
          onClick={(e) => { setRotation((rotation + 90) % 360); e.preventDefault(); e.stopPropagation(); return false; }}>Rotate</button>}
      <div style={
          (rotation === 90 || rotation === 270) ? { height: ref?.current?.width ? ref.current.width : 'auto' } : {}
      }>
      <img
        ref={ref}
        alt="document"
        style={{ 
          maxWidth: modernUI ? "100%" : props.Viewer === 'screener' ? "400px" : "300px", 
          transform: 'translateY(' + ((rotation === 90 || rotation === 270) ? (((ref.current?.width || 0) - (ref.current?.height || 0))/2) : 0) + 'px) ' +
            'translateX(' + ((rotation === 90 || rotation === 270) ? (((ref.current?.height || 0) - (ref.current?.width || 0))/2) : 0) + 'px) ' +
            'rotate(' + rotation + 'deg)',
        }}
        onError={() => isImageError(true)}
        src={props.src}
      />
      </div>
    </>;
  }